import React from 'react';
import GreenButton from '../home/GreenButton';
import { useContactModal } from '../../contexts/ContactModalContext';

const GREEN = '#78BE20';

const ShopHero: React.FC = () => {
  const { openContactModal } = useContactModal();

  return (
    <section id="shop-hero" className="relative bg-black text-white overflow-hidden">
      <div>
        <div className="relative min-h-[70svh] lg:min-h-[520px] lg:h-[calc(60svh_-_var(--header-h,0px))] flex items-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover"
            style={{
              backgroundImage: 'url(/images/clothing-hero.jpg)',
              backgroundPosition: 'center 30%',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-black/10" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />

          <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-16 py-24 lg:py-10">
            <div className="flex items-center gap-5 mb-5">
              <span className="h-px w-12" style={{ backgroundColor: GREEN }} />
              <span className="font-poppins text-[11px] md:text-xs font-semibold tracking-[0.25em] uppercase">
                Custom clothing
              </span>
            </div>
            <h1 className="font-montserrat font-extrabold leading-[1.02] tracking-[-0.03em] text-[clamp(36px,4.4vw,72px)] max-w-2xl">
              <span style={{ color: GREEN }}>Premium garments and customisation,</span>{' '}
              all in one place.
            </h1>
            <p className="font-poppins text-base md:text-lg leading-7 text-white/85 mt-5 max-w-xl">
              Visit our Kidderminster showroom, browse garment samples, and work with our in-house team on
              branded workwear, uniforms, merch and one-off custom pieces.
            </p>
            <div className="flex flex-wrap gap-3 mt-7">
              <GreenButton to="/clothing">
                Browse Garments
              </GreenButton>
              <GreenButton onClick={openContactModal} variant="outline" className="text-white">
                Get in Touch
              </GreenButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopHero;
